module.exports = __webpack_public_path__ + "static/media/banner-clients-05-mobile.7de4a588.jpg";